import * as THREE from 'three'

import Camera from './Camera'
import Renderer from './Renderer'
import World from './world/World'
import Sizes from './utils/Sizes'
import Resources from './utils/Resources'
import Debug from './utils/Debug'
import sources from './sources'

import FBO from './components/FBO'

import { Emitter } from '../events'
import store from '../store'

let instance = null

export default class Experience {
  constructor(el) {
    if (instance) {
      return instance
    }

    instance = this

    // Global access
    window.experience = this

    // Options
    this.canvas = el
    this.debug = new Debug()

    this.sizes = new Sizes()
    this.resources = new Resources(sources)
    this.time = new THREE.Clock()
    this.scene = new THREE.Scene()
    this.camera = new Camera()
    this.renderer = new Renderer()

    this.resources.on('ready', () => {
      this.init()

      Emitter.emit('gl:start')
    })
  }

  init() {
    this.world = new World()
    this.fbo = new FBO()

    if (store.sniffer.isDevice) this.scene.position.y += 0.2

    this.addEvents()
  }

  addEvents() {
    Emitter.on('resize', this.resize)
    Emitter.on('tick', this.update)
  }

  resize = () => {
    this.camera.resize()
    this.renderer.resize()
    this.world.resize()
  }

  update = ({ time }) => {
    this.renderer.update()
    this.world.update(time)
    this.fbo.update(time)
  }
}